module.exports = __webpack_public_path__ + "img/quick-icon03.5e8d1b32.png";